import VueI18n from 'vue-i18n'
import Vue from 'vue'
import { DEFAULT_LANGUAGE, FALLBACK_LANGUAGE } from '@/constants/trans'
import { Trans } from '@/plugins/translation'
import en from '@/lang/en.json'
import fa from '@/lang/fa.json'

Vue.use(VueI18n)

// translation
Vue.prototype.$i18nRoute = Trans.i18nRoute.bind(Trans)

export const i18n = new VueI18n({
  locale: DEFAULT_LANGUAGE, // set locale
  fallbackLocale: FALLBACK_LANGUAGE,
  messages: { en, fa }// set locale messages
})